var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCd = function SvgCd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M22.667 6.498a11.994 11.994 0 0 0-2.182-2.983c-.9-.9-1.909-1.627-2.983-2.182L9.048 9.05l-7.716 8.454a11.994 11.994 0 0 0 2.182 2.983c.9.901 1.909 1.628 2.983 2.182l8.454-7.716 7.716-8.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.515 20.485c.503.504 1.04.953 1.603 1.348L21.833 5.118a12.076 12.076 0 0 0-2.951-2.951L2.167 18.88c.395.564.844 1.101 1.348 1.604Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M3.514 3.514C-.272 7.3-.998 12.986 1.333 17.502l16.17-16.17C12.985-.997 7.3-.27 3.513 3.515ZM20.486 20.485c3.786-3.786 4.513-9.472 2.182-13.988l-16.17 16.17c4.516 2.33 10.202 1.604 13.988-2.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.395 3.651.648 1.993h2.096L7.443 6.876l.648 1.993-1.696-1.232L4.7 8.87l.648-1.993-1.696-1.232h2.096l.647-1.993Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCd;